import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ errorInfo });

    // Auto-recover from DOM manipulation errors (browser extensions, translations)
    const msg = error?.message || '';
    if (
      msg.includes('removeChild') ||
      msg.includes('insertBefore') ||
      msg.includes('not a child')
    ) {
      console.warn('DOM manipulation error detected — auto-reloading');
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[50vh] flex items-center justify-center p-8" data-testid="error-boundary">
          <div className="text-center max-w-lg">
            <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-6">
              <RefreshCw className="w-7 h-7 text-gray-400" />
            </div>
            <h2 className="text-xl font-heading text-gray-700 mb-2">
              Algo no cargó correctamente
            </h2>
            <p className="text-gray-400 text-sm mb-4">
              Pulsa el botón para recargar.
            </p>
            <Button
              onClick={() => window.location.reload()}
              className="bg-[#D4A84B] hover:bg-[#c49b3f] text-white rounded-xl"
              data-testid="error-reload-btn"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Recargar página
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
